"use client";
import {
  useCompositeGroup
} from "../__chunks/3OE5GFUI.js";
import "../__chunks/UYO2XHHT.js";
import "../__chunks/7HVFURXT.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/L4OUMOCQ.js";
import "../__chunks/W2TDKEPX.js";
import "../__chunks/AZVQSWGA.js";

// src/menu/menu-group.tsx
var TagName = "div";
var useMenuGroup = createHook(
  function useMenuGroup2(props) {
    props = useCompositeGroup(props);
    return props;
  }
);
var MenuGroup = forwardRef(function MenuGroup2(props) {
  const htmlProps = useMenuGroup(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuGroup,
  useMenuGroup
};
